export const newGameNotification = {
    type: 'new-game',
    defaultEnabled: true,
    name: 'New Game',
    description: 'Sent when you receive a new playable game in your library.',
    text(data, context) {
        return `You can now play ${data.gameTitle ?? 'a new game'}!${context === 'push' ? ' Tap to view your library.' : ''}`;
    },
    title(_data) {
        return `You got a new game!`;
    },
    link(data) {
        return `/library/${data.gameId}`;
    },
};
//# sourceMappingURL=newGame.js.map